// extracted by mini-css-extract-plugin
export default {"table-listing":"TableListing_table-listing__UD8us"};